import { ErrorResponse, InvalidParam } from '~shared/modules/error-handler';

export const getErrorMsg = (error: ErrorResponse ) => {
  try {
    const [errorData] = Object.values(error['invalidParams']);
    const { reason } = errorData as InvalidParam;

    return reason;
  } catch (e) {
    return error.detail || error.title;
  }
};
